import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { DocumentVersionListItem, IDocumentVersionListItem } from "./documentVersionListItem";

export interface IDocumentVersionListItems extends IListItems<IDocumentVersionListItem> {}

export class DocumentVersionListItems extends ListItems<DocumentVersionListItem> implements IDocumentVersionListItems {
    constructor();
    constructor(obj: IDocumentVersionListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, DocumentVersionListItem);
    }
}